const createWidgetFactory = require('components-framework/widget/create_widget_factory');

const defaultOptions = () => ({
    trackBookingIdOnDialup: Odigeo.BagsAndSeats.trackBookingIdOnDialup,
});

module.exports = createWidgetFactory({
    name: 'bags_and_seats_offline',
    viewClass: require('./view'),
    options: {
        '*': defaultOptions(),
    },
    methods: {
        addBags() {
            this.addBags('link');
        },
        chooseSeats() {
            this.chooseSeats('link');
        },
    },
});
